import React, { useState, useEffect, useRef } from 'react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { BulkAction } from 'Pages/InnerPages/CommissionHold/BulkAction';
import { CustomModal } from 'Components/Modal/CustomModal';
import { Container, Grid, MenuItem, Paper } from '@material-ui/core';
import { LOGOUT } from 'ConstComponents';
import { MaterialSelect } from 'Components/Inputes/FormikMaterialSelect';
import ReactTable from 'Components/ReactTable/ReactTable';
import CircularProgress from '@material-ui/core/CircularProgress';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import { PLEASE_SELECT_VALID } from 'Components/Helper/Messages';
import {
    Select as SELECT,
    GenerateAll
} from 'Components/Api/CommissionHoldAPI';
import { Action } from 'Pages/InnerPages/CommissionHold/Action';

import HOCLoader from 'Components/Loader/HOCLoader';
import Accordion from '@material-ui/core/Accordion';
import HOCAccordion from 'Components/CustomAccordion/HOCAccordion';
import {
    PrimaryButton,
    SecondaryButton
} from 'Components/Inputes/CustomButton';

import {
    GET_Month_FOR_GST,
    GET_YEAR_FOR_GST
} from 'Components/Helper/Messages';

import { Select as WALLET_SELECT } from 'Components/Api/WalletApi';
import { SelectRoleWithoutSupport as USER_TYPE_SELECT_WITHOUT_SUPPORT } from 'Components/Api/UserTypeApi';
import {
    API_USER_CODE,
    RETAILER_CODE,
    CLIENT_CODE
} from 'Components/Helper/Messages';

const CustomAccordion = HOCAccordion(Accordion);
const CustomContainer = HOCLoader(Container);

export const CommissionHoldRequest = () => {
    const classes = commonStyle();
    const formRef = useRef();
    const [transactions, setTransactions] = useState([]);
    const [mainColumns, setMainColumns] = useState([]);
    const [requestArr, setRequestArr] = useState([]);

    const [loading, setLoading] = useState(false);
    const [responseMessage, setResponseMessage] = useState('');
    const [isError, setIsError] = useState(false);
    const [severity, setSeverity] = useState('success');
    const [isOpen, setIsOpen] = useState(false);
    const [RedeemcommissionID, setRedeemcommissionID] = useState(0);
    const [openFilter, setopenFilter] = useState(true);
    const [isBulkCommOpen, setIsBulkCommOpen] = useState(false);
    const [wallets, setWallets] = useState([]);
    const [userTypeList, setUserTypeList] = useState([]);
    const [isRetailer, setIsRetailerRole] = useState(false);
    const [currentUsertypeid] = useState(
        parseInt(localStorage.getItem('UserTypeID'))
    );
    const [
        shouldGetUpdatedDataFromTable,
        setShouldGetUpdatedDataFromTable
    ] = useState(false);
    const [IsUpdateClicked, setIsUpdateClicked] = useState(false);

    const [TakeCount, setTakeCount] = useState(10);
    const [SkipCount, setSkipCount] = useState(0);
    const [totalCount, setTotalCount] = useState(0);

    const [ModelObj] = useState({
        Month: GET_Month_FOR_GST(),
        Year: GET_YEAR_FOR_GST(),
        Status: 'PROCESS',
        GenerateAllRequest: false,
        IsTransfer: false,
        WalletID: 0,
        UserTypeID: 0
    });

    const [Months] = useState([
        { Key: 1, Value: 'January' },
        { Key: 2, Value: 'February' },
        { Key: 3, Value: 'March' },
        { Key: 4, Value: 'April' },
        { Key: 5, Value: 'May' },
        { Key: 6, Value: 'June' },
        { Key: 7, Value: 'July' },
        { Key: 8, Value: 'August' },
        { Key: 9, Value: 'September' },
        { Key: 10, Value: 'October' },
        { Key: 11, Value: 'November' },
        { Key: 12, Value: 'December' }
    ]);

    const [Years, setYears] = useState([]);

    const GetYears = () => {
        var currentYear = new Date().getFullYear();
        var yearList = [];
        for (var year = currentYear - 1; year <= currentYear; year++) {
            yearList.push({ Key: year });
        }
        setYears(yearList);
    };

    const MonthItems = Months.map(({ Key, Value }, index) => (
        <MenuItem key={index} value={Key}>
            {Value}
        </MenuItem>
    ));
    const YearItems = Years.map(({ Key }, index) => (
        <MenuItem key={index} value={Key}>
            {Key}
        </MenuItem>
    ));

    const submithandle = async (values, { setSubmitting, resetForm }) => {
        var requestObj = JSON.stringify(values);

        if (values.GenerateAllRequest) {
            GenerateAllRequest(requestObj);
            return;
        }

        setIsError(false);
        setLoading(true);
        createColumns();
        setTransactions([]);
        setResponseMessage('');
        var response = await SELECT(requestObj);
        setLoading(false);

        if (!response.isAuthorized) LOGOUT();

        setSeverity('success');

        if (!response.status) {
            setIsError(true);
            setSeverity('error');
            setResponseMessage(response.data);

            return;
        }

        setSubmitting(false);
        var data = JSON.parse(response.data);

        setTransactions(data);
    };

    const SelectPending = async () => {
        let jsonObj = {
            Month: GET_Month_FOR_GST(),
            Year: GET_YEAR_FOR_GST(),
            Status: 'PROCESS',
            WalletID: 0,
            UserTypeID: 0
        };

        var requestObj = JSON.stringify(jsonObj);

        setIsError(false);
        setLoading(true);
        createColumns();
        setTransactions([]);
        var response = await SELECT(requestObj);
        setLoading(false);

        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setIsError(true);
            setSeverity('error');
            setResponseMessage(response.data);

            return;
        }
        setSeverity('success');
        var data = JSON.parse(response.data);

        setTransactions(data);
    };

    const validationSchema = Yup.object({
        Month: Yup.string()
            .nullable(PLEASE_SELECT_VALID + 'month')
            .required(PLEASE_SELECT_VALID + 'month'),
        Year: Yup.string()
            .nullable(PLEASE_SELECT_VALID + 'year')
            .required(PLEASE_SELECT_VALID + 'year')
    });

    useEffect(() => {
        createColumns();
        SelectPending();
        GetYears();
        CheckUserRole();
        selectWallets();
        if (!isRetailer) {
            selectUserTypes();
        }
    }, []);

    const CheckUserRole = () => {
        if (RETAILER_CODE === parseInt(currentUsertypeid))
            setIsRetailerRole(true);
        if (API_USER_CODE === parseInt(currentUsertypeid))
            setIsRetailerRole(true);

        createColumns();
    };
    const selectUserTypes = async () => {
        if (RETAILER_CODE === parseInt(currentUsertypeid)) {
            return;
        }
        if (API_USER_CODE === parseInt(currentUsertypeid)) {
            return;
        }
        if (CLIENT_CODE === parseInt(currentUsertypeid)) {
            return;
        }
        const response = await USER_TYPE_SELECT_WITHOUT_SUPPORT();

        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setSeverity('error');
            setIsError(true);
            setResponseMessage(response.data);
        }

        var data = JSON.parse(response.data);
        setUserTypeList(data);
    };
    const selectWallets = async () => {
        var request = {
            ID: 0
        };
        var json = JSON.stringify(request);
        const response = await WALLET_SELECT(json);

        if (!response.isAuthorized) {
            LOGOUT();
        }
        if (!response.status) {
            setResponseMessage(response.data);
            setIsError(true);
        }

        var data = JSON.parse(response.data);
        setWallets(data);
    };
    const createColumns = () => {
        var columns = [];

        var options = [
            {
                Title: 'Action',
                disabledOn: ['SUCCESS', 'FAILURE'],
                statusIndex: 7,
                Callback: (values) => {
                    GetAction(values[0]);
                }
            }
        ];
        columns.push({
            label: 'More',
            name: 'RedeemcommissionID',
            MoreMenu: true,
            options: options
        });

        columns.push({
            label: '#',
            name: 'RedeemcommissionID',
            hide: true
        });
        columns.push({
            label: 'DOC',
            name: 'DOC'
        });
        columns.push({
            label: 'Updated DOC',
            name: 'UpdatedDOC'
        });
        columns.push({
            label: 'Firm',
            name: 'FirmName'
        });

        columns.push({
            label: 'YearMonth',
            name: 'LastYearMonth'
        });
        columns.push({
            label: 'Wallet',
            name: 'WalletName'
        });
        columns.push({
            label: 'Amount',
            name: 'Amount',
            numeric: true
        });
        columns.push({
            label: 'Status',
            name: 'Status',
            customStatus: true
        });
        columns.push({
            label: 'Admin Remark',
            name: 'AdminRemark',
            ReadOnlyTextArea: true,
            textwrap: 60
        });

        columns.push({
            label: '#',
            name: 'WalletID',
            hide: true
        });

        setMainColumns(columns);
    };

    const refreshForm = () => {
        if (!formRef.current) return;

        formRef.current.handleSubmit();
    };

    const GetAction = (RedeemcommissionID) => {
        setRedeemcommissionID(RedeemcommissionID);
        setIsOpen(true);
    };

    const GenerateAllRequest = async (requestObj) => {
        setIsError(false);
        setLoading(true);
        createColumns();
        setTransactions([]);

        var response = await GenerateAll(requestObj);
        setLoading(false);

        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setIsError(true);
            setSeverity('error');
            setResponseMessage(response.data);

            return;
        }
        setSeverity('success');
        var data = JSON.parse(response.data);

        setTransactions(data);
    };

    const handleTransferAllClick = (e) => {
        setShouldGetUpdatedDataFromTable(true);
        setIsUpdateClicked(true);
    };

    const ProcessUpdatedData = (data) => {
        setShouldGetUpdatedDataFromTable(false);
        if (IsUpdateClicked) {
            UpdateBulkClick(data);
            return;
        }
    };
    const UpdateBulkClick = async (requestArr, resetForm) => {
        setIsUpdateClicked(false);
        if (requestArr.length <= 0) {
            setSeverity('error');
            setIsError(true);
            setResponseMessage('Please select one or more user(s)');
            return;
        }

        let request = [];
        requestArr.forEach((element) => {
            let RedeemcommissionID = element[0].value;
            let WalletID = element[10].value;
            let Status = element[8].value;

            request.push({
                RedeemcommissionID: RedeemcommissionID,
                WalletID: WalletID,
                Status: Status
            });
        });
        setRequestArr(request);
        setIsBulkCommOpen(true);
    };

    return (
        <CustomContainer
            isLoading={loading}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Formik
                innerRef={formRef}
                initialValues={ModelObj}
                validationSchema={validationSchema}
                onSubmit={submithandle}
                resetForm={ModelObj}
                render={({ values, setFieldValue, handleSubmit }) => {
                    return (
                        <Form style={{ marginBottom: '15px' }}>
                            <Grid item xs={12}>
                                <Paper>
                                    <CustomAccordion
                                        title={'Commission Hold Request'}
                                        open={openFilter}
                                        setOpen={(value) =>
                                            setopenFilter(value)
                                        }
                                    >
                                        <Grid container spacing={2}>
                                            <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={2}
                                                lg={2}
                                            >
                                                <MaterialSelect
                                                    label="Month"
                                                    name="Month"
                                                    title="Month"
                                                >
                                                    {MonthItems}
                                                </MaterialSelect>
                                            </Grid>

                                            <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={2}
                                                lg={2}
                                            >
                                                <MaterialSelect
                                                    label="Year"
                                                    name="Year"
                                                    title="Year"
                                                >
                                                    {YearItems}
                                                </MaterialSelect>
                                            </Grid>

                                            <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={2}
                                                lg={2}
                                            >
                                                <MaterialSelect
                                                    label="Wallet"
                                                    name="WalletID"
                                                    title="Select Wallet"
                                                >
                                                    <MenuItem key="0" value="0">
                                                        All Wallet
                                                    </MenuItem>
                                                    {wallets.map((item) => (
                                                        <MenuItem
                                                            key={item.WalletID}
                                                            value={
                                                                item.WalletID
                                                            }
                                                        >
                                                            {item.Name}
                                                        </MenuItem>
                                                    ))}
                                                </MaterialSelect>
                                            </Grid>
                                            <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={2}
                                                lg={2}
                                            >
                                                <MaterialSelect
                                                    label="Role"
                                                    name="UserTypeID"
                                                    title="Select Role"
                                                >
                                                    <MenuItem key="0" value="0">
                                                        All Role
                                                    </MenuItem>
                                                    {userTypeList.map(
                                                        (item) => (
                                                            <MenuItem
                                                                key={
                                                                    item.UserTypeID
                                                                }
                                                                value={
                                                                    item.UserTypeID
                                                                }
                                                            >
                                                                {item.UserType}
                                                            </MenuItem>
                                                        )
                                                    )}
                                                </MaterialSelect>
                                            </Grid>
                                            <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={2}
                                                lg={2}
                                            >
                                                <MaterialSelect
                                                    label="Status"
                                                    name="Status"
                                                    title="Status"
                                                >
                                                    <MenuItem
                                                        key="ALL"
                                                        value="ALL"
                                                    >
                                                        All Status
                                                    </MenuItem>
                                                    <MenuItem
                                                        key="SUCCESS"
                                                        value="SUCCESS"
                                                    >
                                                        ACCEPT
                                                    </MenuItem>
                                                    <MenuItem
                                                        key="FAILURE"
                                                        value="FAILURE"
                                                    >
                                                        REJECT
                                                    </MenuItem>
                                                    <MenuItem
                                                        key="PROCESS"
                                                        value="PROCESS"
                                                    >
                                                        PROCESS
                                                    </MenuItem>
                                                </MaterialSelect>
                                            </Grid>
                                            <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={2}
                                                lg={2}
                                            >
                                                <PrimaryButton
                                                    type="submit"
                                                    title="submit"
                                                    className={
                                                        classes.CustomPrimaryButtonStyle
                                                    }
                                                    disabled={loading}
                                                    onClick={(e) => {
                                                        setFieldValue(
                                                            'GenerateAllRequest',
                                                            false
                                                        );

                                                        handleSubmit(e);
                                                    }}
                                                >
                                                    Search
                                                </PrimaryButton>
                                                {loading && (
                                                    <CircularProgress
                                                        size={24}
                                                        className={
                                                            classes.buttonProgress
                                                        }
                                                    />
                                                )}
                                            </Grid>

                                            <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={3}
                                                lg={3}
                                            >
                                                <SecondaryButton
                                                    disabled={loading}
                                                    title="Generate All Request"
                                                    onClick={(e) => {
                                                        setFieldValue(
                                                            'GenerateAllRequest',
                                                            true
                                                        );

                                                        handleSubmit(e);
                                                    }}
                                                />
                                                {loading && (
                                                    <CircularProgress
                                                        size={24}
                                                        className={
                                                            classes.buttonProgress
                                                        }
                                                    />
                                                )}
                                            </Grid>

                                            <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={3}
                                                lg={3}
                                            >
                                                <SecondaryButton
                                                    disabled={loading}
                                                    title="Transfer All User"
                                                    onClick={
                                                        handleTransferAllClick
                                                    }
                                                />
                                                {loading && (
                                                    <CircularProgress
                                                        size={24}
                                                        className={
                                                            classes.buttonProgress
                                                        }
                                                    />
                                                )}
                                            </Grid>
                                        </Grid>
                                    </CustomAccordion>
                                </Paper>
                            </Grid>
                        </Form>
                    );
                }}
            />

            <ReactTable
                data={transactions}
                getCallback={({ currentPage, RowsPerPage }) => {
                    setTakeCount(RowsPerPage);
                    setSkipCount(RowsPerPage * currentPage);
                }}
                count={totalCount}
                columns={mainColumns}
                getUpdatedData={(data) => {
                    ProcessUpdatedData(data);
                    setShouldGetUpdatedDataFromTable(false);
                }}
                shouldGetUpdatedData={shouldGetUpdatedDataFromTable}
                isSelectableRows={'multiple'}
            />

            {isOpen ? (
                <CustomModal
                    isOpen={isOpen}
                    title="Commission Hold Request"
                    width="75%"
                    onDismissCallback={(value) => {
                        setIsOpen(value);
                        refreshForm();
                    }}
                >
                    <Action
                        RedeemcommissionID={RedeemcommissionID}
                        onDismissCallback={(value) => {
                            setIsOpen(value);
                            refreshForm();
                        }}
                    />
                </CustomModal>
            ) : null}

            {isBulkCommOpen ? (
                <CustomModal
                    isOpen={isBulkCommOpen}
                    title="Commission Hold Request"
                    width="75%"
                    onDismissCallback={(value) => {
                        setIsBulkCommOpen(value);
                        refreshForm();
                    }}
                >
                    <BulkAction
                        requestArr={requestArr}
                        onDismissCallback={(value) => {
                            setIsBulkCommOpen(value);
                            refreshForm();
                            setTransactions([]);
                            createColumns();
                        }}
                    />
                </CustomModal>
            ) : null}
        </CustomContainer>
    );
};
